import React from 'react';

import { DocumentType } from '@lglp/prismic-client';
import { useTranslation } from 'react-i18next';
import { Redirect, useParams } from 'react-router';

import { syncDocumentByUid } from '../../helpers/loading';
import useDocumentByUid from '../../hooks/useDocumentByUid';
import { SSRComponent } from '../../types/component';

const defaultRedirect = ({ from, to }: { from: string; to: string }) => {
  const CustomRedirect: SSRComponent = () => {
    return <Redirect to={to} />;
  };

  CustomRedirect.getInitialProps = () => {
    throw { status: 302, context: { url: to } };
  };

  return {
    path: from,
    component: CustomRedirect,
  };
};

const articleRedirect = ({ from }: { from: string }) => {
  const CustomRedirect: SSRComponent = () => {
    const { articleUid } = useParams<{ articleUid: string }>();
    const { i18n } = useTranslation();

    const { error, data, loading } = useDocumentByUid(
      DocumentType.HOT_ARTICLE,
      articleUid
    );

    if (data) {
      return (
        <Redirect
          to={`/${i18n.languages[0]}/${
            i18n.languages[0] === 'fr' ? 'actualite' : 'news'
          }/${articleUid}`}
        />
      );
    }

    if (loading || (!error && !data)) {
      return null;
    }

    return <Redirect to={`/${i18n.languages[0]}/${articleUid}`} />;
  };

  CustomRedirect.getInitialProps = async (serverData) => {
    const articleUid = serverData.match.params.articleUid;
    const { data } = await syncDocumentByUid(
      DocumentType.HOT_ARTICLE,
      articleUid,
      serverData
    );

    if (data) {
      throw {
        status: 302,
        context: {
          url: `/${serverData.language}/${
            serverData.language === 'fr' ? 'actualite' : 'news'
          }/${articleUid}`,
        },
      };
    }

    throw {
      status: 302,
      context: { url: `/${serverData.language}/${articleUid}` },
    };
  };

  return {
    path: from,
    component: CustomRedirect,
  };
};

export const REDIRECT_ROUTES = [
  defaultRedirect({
    from: '/fr/activites',
    to: '/fr/nos-branches-d-activites',
  }),
  defaultRedirect({
    from: '/fr/contact',
    to: '/fr/contacts',
  }),
  defaultRedirect({
    from: '/en/contact',
    to: '/en/contacts',
  }),
  defaultRedirect({
    from: '/fr/innovation-par-la-poste',
    to: '/fr/l-innovation-au-coeur-du-groupe-la-poste',
  }),
  defaultRedirect({
    from: '/fr/geopost-le-colis-meme-a-lautre-bout-du-monde',
    to: '/fr/geopost-le-colis-meme-a-l-autre-bout-du-monde',
  }),
  defaultRedirect({
    from: '/fr/organigramme',
    to: '/fr/notre-gouvernance-le-comite-executif',
  }),
  defaultRedirect({
    from: '/en/services-mail-parcels',
    to: '/en/our-public-service-missions',
  }),
  defaultRedirect({
    from: '/fr/missions-de-service-public',
    to: '/fr/les-4-missions-de-service-public',
  }),
  defaultRedirect({
    from: '/en/la-banque-postale-the-bank-for-all',
    to: '/en/la-banque-postale',
  }),
  defaultRedirect({
    from: '/en/geopost--parcels-even-at-the-other-end-of-the-world',
    to: '/en/geopost-dpdgroup-parcel-delivery-in-france-and-abroad',
  }),
  defaultRedirect({
    from: '/fr/espace-presse/:pressReleaseDoc',
    to: '/fr/hub-communiques-de-presse',
  }),
  defaultRedirect({
    from: '/en/newsroom/:pressReleaseDoc',
    to: '/en/press-releases',
  }),
  articleRedirect({
    from: '/fr/article/:articleUid',
  }),
  articleRedirect({
    from: '/en/article/:articleUid',
  }),
];
